module.exports = "<shared-header></shared-header>\r\n<div class='container'>\r\n  <div class=\"content\">\r\n      <router-outlet></router-outlet>\r\n  </div>\r\n</div>\r\n<shared-footer></shared-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app/app.component.html
// module id = ./src/app/components/app/app.component.html
// module chunks = main